








import {
  computed,
  defineComponent,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const formattedName = computed(() => props.title.replace(/-/g, '‑'));

    return {
      formattedName,
    };
  },
});
